import { render, staticRenderFns } from "./ActuPage.vue?vue&type=template&id=346476de&scoped=true"
import script from "./ActuPage.vue?vue&type=script&lang=js"
export * from "./ActuPage.vue?vue&type=script&lang=js"
import style0 from "./ActuPage.vue?vue&type=style&index=0&id=346476de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346476de",
  null
  
)

export default component.exports